import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { AvailableIcon, CrossIcon } from '@sainsburys-tech/bolt-icons'
import { createGolNonContentDataAttributes } from '../../../helpers/tracking'
import { agnostifyUrl } from '../../../helpers/utils'
import { C005Props } from './types'
import { LinkItem, Item } from './C005.styles'

const C005 = ({ section, onLinkClick }: C005Props): React.ReactElement => {
  const iconComponents = {
    tick: <AvailableIcon filled fill='#2e7d32' width='20' height='20' style={{ flexShrink: 0 }} />,
    close: <CrossIcon filled fill='#e53212' width='20' height='20' style={{ flexShrink: 0 }} />
  }
  const theme = useContext(ThemeContext)
  const isSainsburys = theme?.channel === 'sainsburys'

  const addGolTracking = (event: React.MouseEvent<HTMLElement, MouseEvent>, linkText?: string, heading?: string) => {
    const dataAttributes = createGolNonContentDataAttributes(
      'link',
      'click',
      'nav link',
      `C005-${heading?.toLowerCase() ?? 'NA'}-${linkText?.toLowerCase()}`,
      'navigation'
    )
    Object.keys(dataAttributes).forEach((attribute) =>
      event.currentTarget.setAttribute(attribute, dataAttributes[attribute])
    )
  }

  const ctaClick = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    linkText?: string,
    heading?: string,
    headingUrl?: string
  ) => {
    if (onLinkClick) {
      onLinkClick(event, headingUrl)
    }
    addGolTracking(event, linkText, heading)
  }

  return (
    <div>
      {section?.map((child, index) => {
        const headingUrl = child.link?.url
        const headingTitle = child.link?.title
        const headingText = child?.heading
        return (
          <div key={index} data-test={`c005-list-${index}`}>
            {headingText && (
              <h3
                data-test={`c005-heading-${index}`}
                className={isSainsburys && 'ln-u-display-1'}
                style={{
                  fontSize: isSainsburys ? undefined : '16px',
                  marginBottom: '16px'
                }}
              >
                {headingUrl ? (
                  <a
                    data-test={`c005-heading-link-${index}`}
                    href={agnostifyUrl(headingUrl)}
                    title={headingTitle}
                    onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) =>
                      // both linkText & heading are of the same value here
                      ctaClick(e, headingText, headingText, headingUrl)
                    }
                    style={{ textDecoration: 'underline' }}
                  >
                    {headingText}
                  </a>
                ) : (
                  headingText
                )}
              </h3>
            )}
            <ul style={{ marginLeft: 0 }}>
              {child.items.map((item, i) => {
                const itemUrl = item.link?.url
                const itemTitle = item.link?.title
                const ListItem: React.ElementType = itemUrl ? LinkItem : Item
                return (
                  <ListItem
                    key={i}
                    data-test={`c005-${index}-item-${i}`}
                    href={itemUrl ? agnostifyUrl(itemUrl) : undefined}
                    title={itemTitle ?? undefined}
                    onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) =>
                      ctaClick(e, item?.copy, headingText, itemUrl)
                    }
                  >
                    {(item.iconType === 'close' || item.iconType === 'tick') && iconComponents[item.iconType]}
                    {item.copy}
                  </ListItem>
                )
              })}
            </ul>
          </div>
        )
      })}
    </div>
  )
}

export default C005
